import type { NovidadeSection } from '@/data/news/vsl-dinamica-2';

export function NovidadeSections({ sections }: { sections?: NovidadeSection[] }) {
  if (!sections?.length) return null;
  return (
    <div className="space-y-5 py-2">
      {sections.map((section) => (
        <section key={section.title} className="space-y-2.5">
          <h4 className="text-[14px] font-semibold leading-snug text-foreground">{section.title}</h4>
          {section.paragraphs?.map((paragraph) => (
            <p key={paragraph} className="text-[13.5px] leading-[1.6] text-foreground/75">{paragraph}</p>
          ))}
          {section.steps && (
            <ol className="list-decimal space-y-3 pl-5 text-[13.5px] leading-[1.6] text-foreground/75 marker:font-semibold marker:text-[#4B7BFF]">
              {section.steps.map((step) => <li key={step} className="pl-1">{step}</li>)}
            </ol>
          )}
        </section>
      ))}
    </div>
  );
}
